var render, staticRenderFns
import script from "./LzFormItem.vue?vue&type=script&lang=js"
export * from "./LzFormItem.vue?vue&type=script&lang=js"
import style0 from "./LzFormItem.vue?vue&type=style&index=0&id=8f2c4b78&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2c4b78",
  null
  
)

export default component.exports